import { isF1Device } from '../../utils/isF1Device';
import { useF1NetworkState } from '../../context/F1NetworkStateStore';

const OfflineBanner = () => {
  const { isOffline } = useF1NetworkState();
  const isF1 = isF1Device();

  if (!isF1 || !isOffline) {
    return null;
  }

  return (
    <div className="bg-brand-black flex items-center justify-center gap-2 py-2 px-4">
      <svg className="w-5 h-5 shrink-0 animate-spin text-grey-lightest" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.3" />
        <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
      </svg>
      <span className="text-sm font-medium text-grey-lightest">You appear to be offline. Reconnecting...</span>
    </div>
  );
};

export default OfflineBanner;
